// extracted by mini-css-extract-plugin
export var container = "PrivacyPolicyPage-module--container--47e03";
export var content = "PrivacyPolicyPage-module--content--522b1";
export var header = "PrivacyPolicyPage-module--header--d2a44";
export var intro = "PrivacyPolicyPage-module--intro--137d5";
export var languageBanner = "PrivacyPolicyPage-module--language-banner--b017c";
export var subtitle = "PrivacyPolicyPage-module--subtitle--2fa4c";
export var title = "PrivacyPolicyPage-module--title--3612a";
export var warning = "PrivacyPolicyPage-module--warning--ae6b2";